import { UserPlan } from '../../types';

const limits: Record<UserPlan, number> = {
  free: 10,
  basic: 50,
  business: 150,
  premium: Infinity,
};

export const getLeadsLimit = (plan: UserPlan): number => {
  return limits[plan];
};
